import { useState } from 'react';
import { observer } from 'mobx-react';
import { FiChevronDown } from 'react-icons/fi';
import { Anchor } from '@strategies/react-anchors';
import { henshu, useHenshu } from '@strategies/henshu';

import NavSection from '../NavSection';
import { DRAFT_PLAN_LINK, ENGAGEMENT_LINK, ENGAGEMENT_LINK_ES, FINAL_DRADT_PLAN_LINK, PROVIDE_COMMENTS, CROSSING_SURVEY_30, CROSSING_SURVEY_PLAN, FINAL_CROSSING_SURVEY_PLAN } from '../../config';


export default observer(function Welcome() {
    const { bindTo } = useHenshu();
    const [promptHidden, setPromptHidden] = useState(false);

    return (
        <div className="Welcome-wrap">
            <NavSection name="Welcome" index={0}>
                <Anchor onChange={(anchor) => setPromptHidden(anchor.placement === 'offscreen')} />
                <div className='logo'></div>

                <div className="links">
                    {
                        //      <div className="video-container">
                        //     <video playsInline controls>
                        //         <source src="https://firebasestorage.googleapis.com/v0/b/downtown-littlerock-masterplan.appspot.com/o/IMG_4205.MOV?alt=media&token=7d9bdc47-abc1-49cf-a852-de11330ba8f0" type="video/mp4" />
                        //         Your browser does not support the video tag.
                        //     </video>
                        // </div>
                        //  <henshu.richtext {...bindTo('engage.calendar.body')} />
                    }


                    {
                        <div className='links--buttons'>

                            {/* <henshu.a
                                className="button with-arrow"
                                href={CROSSING_SURVEY_30}
                                target={'_blank'}
                                {...bindTo('enegage.welcome.button.the30crossingsurvey')}
                            /> */}
                            {/* <henshu.a
                                className="button with-arrow"
                                href={CROSSING_SURVEY_PLAN}
                                target={'_blank'}
                                {...bindTo('enegage.welcome.button.the30crossingplan')}
                            /> */}

                            <henshu.a
                                className="button with-arrow"
                                href={FINAL_CROSSING_SURVEY_PLAN}
                                target={'_blank'}
                                {...bindTo('enegage.welcome.button.final30crossingplan')}
                            />


                        </div>

                    }
                </div>

            </NavSection>

            <footer
                className={promptHidden ? 'hidden' : ''}
                onClick={() => window.scrollTo({ top: window.innerHeight - 100, left: 0, behavior: 'smooth' })}
            >
                <FiChevronDown />
            </footer>
        </div>
    );
});
